import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { partnerClientActions } from '../actions/partner-client.actions';
import { PartnerClientService } from '../services/partner-client.service';

@Injectable()
export class PartnerClientEffects {
    public loadClients$ = createEffect(() =>
        this.actions$.pipe(
            ofType(partnerClientActions.loadClients),
            switchMap(() =>
                this.partnerClientService.list().pipe(
                    map((clients) => partnerClientActions.loadClientsSuccess({ clients })),
                    catchError((error: Error) => of(partnerClientActions.loadClientsFailure({ error: error.message }))),
                ),
            ),
        ),
    );

    public createClient$ = createEffect(() =>
        this.actions$.pipe(
            ofType(partnerClientActions.createClient),
            mergeMap(({ body }) =>
                this.partnerClientService.create(body).pipe(
                    map((client) => partnerClientActions.createClientSuccess({ client })),
                    catchError((error: Error) => of(partnerClientActions.createClientFailure({ error: error.message }))),
                ),
            ),
        ),
    );

    public rotateSecret$ = createEffect(() =>
        this.actions$.pipe(
            ofType(partnerClientActions.rotateSecret),
            mergeMap(({ id }) =>
                this.partnerClientService.rotateSecret(id).pipe(
                    map((client) => partnerClientActions.rotateSecretSuccess({ client })),
                    catchError((error: Error) => of(partnerClientActions.rotateSecretFailure({ error: error.message }))),
                ),
            ),
        ),
    );

    public revokeClient$ = createEffect(() =>
        this.actions$.pipe(
            ofType(partnerClientActions.revokeClient),
            mergeMap(({ id }) =>
                this.partnerClientService.revoke(id).pipe(
                    map(() => partnerClientActions.revokeClientSuccess({ id })),
                    catchError((error: Error) => of(partnerClientActions.revokeClientFailure({ error: error.message }))),
                ),
            ),
        ),
    );

    public constructor(
        private readonly actions$: Actions,
        private readonly partnerClientService: PartnerClientService,
    ) {}
}
